"use strict";

define('model/workflow.routing',['./base'], function (BaseModel) {
  var WorkflowRouting = BaseModel.extend({}, {
    allApprovals: function allApprovals(docId) {
      return this.createCollection('/rs/api/workflow/summary/document/:documentId').params({
        documentId: docId
      });
    },
    allApprovalsByDocumentId: function allApprovalsByDocumentId(docId) {
      return this.createCollection('/rs/api/workflow/summary/document/:documentId').addAdapter({
        filter: function filter(data) {
          return data.CERTIFY;
        }
      }).params({
        documentId: docId
      });
    },
    allHistoricalApprovals: function allHistoricalApprovals(docId) {
      return this.createCollection('/rs/api/workflow/history/document/:documentId').params({
        documentId: docId
      });
    }
  });
  return WorkflowRouting;
});

